import React, { useEffect, useState } from "react";
import Autosuggest from "react-autosuggest";
import { v4 as uuidv4 } from "uuid";
import { Constants } from "../../../../@types/Constants";
import { ICoordinates } from "../../../../@types/ICoordinates";
import { ISuggestion } from "../../../../@types/ISuggestion";
import { useHotels } from "../../../../hooks/useHotels";
import { searchServiceProvider } from "../../../../services/ServiceProvider";
import { Storage } from "../../../../utils/storage";
import {
  CurrentLocation,
  SearchResults,
  SectionContainer,
  Wrapper,
  renderInputComponent,
  renderSectionTitle,
  setOverlayTop,
  shouldRenderSuggestions,
} from "./AutoSuggest";
import {
  clearSearch,
  emptyResults,
  truncateString,
} from "./SearchAutoComplete.module.scss";
import { ISearchAutoComplete } from "./SearchAutoCompleteProps";
import { useMobileDetectContext } from "../../../../context/MobileDetectContext";
import useCountries from "../../../../hooks/useCountries";
const LocationIcon =
  require("../../../../svg/icon-current-location.svg").default;

const SearchAutoComplete: React.FC<ISearchAutoComplete> = (props) => {
  const hotels = useHotels();
  const countries = useCountries();
  const { isMobileOnly } = useMobileDetectContext();
  const [value, setValue] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>("");
  const [suggestions, setSuggestions] = useState<Array<ISuggestion>>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMyLocation, setIsMyLocation] = useState<boolean>(false);
  const setCoordinates = props.setCoordinates;
  const [errors, setErrors] = useState(props.error);
  const [isoptionSelected, setIsoptionSelected] = useState("Initial");
  const [sessionToken, setSessionToken] = useState<string>("");

  useEffect(() => {
    setSessionToken(uuidv4());
  }, []);

  useEffect(() => {
    setValue(
      props.locationError
        ? "My Current Location"
        : props.searchString
        ? props.searchString
        : ""
    );
  }, [props.searchString]);

  useEffect(() => {
    setErrors(props.error);
  }, [props.error]);

  const parseSuggestionResponse = (data: any) => {
    const results = [];
    if (data?.length > 0) {
      results.push({
        type: "",
        data,
        class: "hotels",
      });
    }
    if (data?.length === 0) {
      results.push({
        type: "No destination found. Please search again.",
        data,
        class: emptyResults,
      });
    }
    return results;
  };

  const formatSuggestionName = (name: string, searchValue = "") => {
    const lowerName = name?.toLowerCase();
    const lowerSearchValue = searchValue?.toLowerCase();
    const index = lowerName?.indexOf(lowerSearchValue);

    if (index !== -1) {
      const highlightedPart = name?.slice(index, index + searchValue.length);
      return (
        <span>
          {name?.substr(0, index)}
          <strong>{highlightedPart}</strong>
          {name?.substr(index + searchValue.length)}
        </span>
      );
    } else {
      return name;
    }
  };

  useEffect(() => {
    const abortController = new AbortController();
    const fetchData = async (inputValue: string) => {
      // const config = {
      //   cancelToken: source.token,
      //   headers: {
      //     "api-key": process.env.GATSBY_CORE_API_KEY,
      //   },
      // };
      // const escapedSearchValue = encodeURIComponent(inputValue);
      // let autocompleteUrl = `${process.env.GATSBY_CORE_BASE_URL}/api/autocomplete?search=${escapedSearchValue}&site=31`;

      // if (brand && brand.brand_code) {
      //   autocompleteUrl += `&brand=${brand.brand_code}`;
      // }
      // Axios.get(autocompleteUrl, config).then((res) => {
      //   setIsLoading(false);
      //   const parsedSuggestions = parseSuggestionResponse(res.data);
      //   const recentSearches = Storage.GetLocalStorageValue(Constants.RECENT_SEARCH_KEY) || [{
      //   type: "",
      //   data: [{name: ""}]
      // }];
      // parsedSuggestions.push(recentSearches[0]);
      //   setSuggestions(parsedSuggestions);
      // }).catch((err) => {
      //   // eslint-disable-next-line no-console
      //   console.error(err);
      // });
      // const guestServices = await guestServiceProvider();
      // const response: ISearchResultResponse =
      //   await guestServices.getSearchResults(inputValue, abortController);
      try {
        const searchServices = await searchServiceProvider();
        const response = await searchServices.getPlaces(
          inputValue,
          sessionToken,
          abortController
        );
        const suggest: any = await response?.placesSearch?.results;
        setIsLoading(false);

        const parsedSuggestions = parseSuggestionResponse(suggest, inputValue);
        const recentSearches = Storage.GetLocalStorageValue(
          Constants.RECENT_SEARCH_KEY
        ) || [
          {
            type: "",
            data: [{ description: "" }],
          },
        ];
        if (inputValue.length < 3) {
          parsedSuggestions.push(recentSearches[0]);
        } else {
          if (!parsedSuggestions[0]?.data?.length) {
            parsedSuggestions.push({
              type: "",
              data: [{ description: "" }],
              class: "",
            });
          }
        }
        setSuggestions(parsedSuggestions);
      } catch (e) {
        setIsLoading(false);
        console.error(e);
      }
    };

    if (inputValue === "") {
      setIsLoading(false);
    } else if (inputValue.length >= 3) {
      fetchData(inputValue);
    } else if (inputValue.length < 3) {
      const isExist = suggestions.find(
        (item) => item.type === "Recent Searches"
      );
      if (!isExist) {
        const recentSearches =
          Storage.GetLocalStorageValue(Constants.RECENT_SEARCH_KEY) || [];
        const isExistFindHotels = suggestions.some((item) =>
          item.data?.some((innerItem) => innerItem.type === "find-hotels")
        );
        const findHotels = isExistFindHotels
          ? []
          : [
              {
                data: [
                  { description: "", class: "hotels", type: "find-hotels" },
                ],
              },
            ];
        setSuggestions([...findHotels, ...suggestions, ...recentSearches]);
      }
    }

    return () => {
      inputValue.length >= 2 && setIsLoading(true);
      // source.cancel("Operation canceled due to new request.");
      abortController.abort();
    };
  }, [inputValue]);

  const onSuggestionsFetchRequested = async ({
    value,
    reason,
  }: {
    value: string;
    reason: string;
  }) => {
    if (!value || (reason === "input-focused" && location.pathname == "/")) {
      const recentSearches =
        Storage.GetLocalStorageValue(Constants.RECENT_SEARCH_KEY) || [];
      const isExistFindHotels = suggestions.some((item) =>
        item.data?.some((innerItem) => innerItem.type === "find-hotels")
      );
      const findHotels = isExistFindHotels
        ? []
        : [
            {
              data: [{ description: "", class: "hotels", type: "find-hotels" }],
            },
          ];
      setSuggestions([...findHotels, ...recentSearches]);
    } else {
      setInputValue(value);
    }
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
    setInputValue("");
  };
  const onSuggestionSelected = async (
    _event: any,
    { suggestion }: { suggestion: any }
  ) => {
    setIsoptionSelected("Selected");
    setTimeout(() => {
      props.setSearchStringStatus("Selected");
    }, 0);
    // setSelectedSuggestion(suggestion.name);
    const alias = null;
    if (suggestion.type === "clear") {
      handleClearSearch();
    } else if (suggestion.type === "find-hotels") {
      getLocation();
    } else {
      try {
        const abortController = new AbortController();
        const searchServices = await searchServiceProvider();
        /**
         * TODO: remove get place details call, we should get coordinates in placesSearch query from GAPI -- need to confirm with Ravi
         */
        const response = await searchServices.getPlaceDetails(
          suggestion.placeId,
          sessionToken,
          suggestion.placeType,
          abortController
        );
        const { details } = await response?.placesDetails;
        if (details) {
          const { coordinates } = details.geometry;

          let hotelPath = null;
          if (["other"].includes(suggestion?.placeType)) {
            const country = countries.find(
              (item: any) => item.placeId === suggestion?.placeId
            );
            hotelPath = country?.redirectUrl || null;
          }
          // Check if the suggestion is of type 'lodging' or 'hotel'
          if (["lodging", "hotel"].includes(suggestion?.placeType)) {
            // Find the hotel with the matching placeId
            const hotel = hotels.find(
              (item: any) => item.placeId === suggestion?.placeId
            );
            hotelPath = hotel?.path?.alias || null;
          }
          if (hotelPath && suggestion?.metadata) {
            suggestion.metadata.customUrl = hotelPath;
          }
          const _coords: ICoordinates = {
            name: suggestion.description,
            lat:
              suggestion?.metadata?.coordinates?.latitude ||
              coordinates?.latitude,
            lon:
              suggestion?.metadata?.coordinates?.longitude ||
              coordinates?.longitude,
            brandId: suggestion.brand_id,
            type:
              suggestion?.placeType === "lodging" ||
              suggestion.placeType === "hotel" ||
              (suggestion?.metadata?.customUrl &&
                suggestion.metadata.customUrl.trim() !== "")
                ? suggestion.placeType === "locality"
                  ? "city"
                  : suggestion.placeType
                : "other",
            searchTypeGapi: suggestion?.placeType,
            placeId: suggestion.placeId,
            alias: hotelPath || suggestion?.metadata?.customUrl || "",
            suggestionObj: suggestion,
            country: suggestion.country,
          };
          setSessionToken(uuidv4()); // Generate a new session token
          setCoordinates ? setCoordinates(_coords) : null;
          setIsMyLocation(false);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };
  const getSuggestionValue = (suggestion: any) => suggestion.description;

  const renderSuggestionsContainer = ({
    containerProps,
    children,
  }: {
    containerProps: any;
    children: any;
  }) => {
    let suggestionsLength = 1;
    if (children != null) {
      suggestionsLength =
        children[0]?.props?.children[0]?.props?.section?.data.length;
    }
    return (
      <div aria-label="Hotel Search Results" {...containerProps}>
        <SectionContainer>
          {/* {(suggestionsLength>1 || children?.length > 1) ? <SearchResults>{children}</SearchResults> : ''} */}
          <SearchResults>{children}</SearchResults>
        </SectionContainer>
      </div>
    );
  };

  const handleClearSearch = () => {
    setSessionToken(uuidv4()); // Generate a new session token
    Storage.ClearLocalStorageValue(Constants.RECENT_SEARCH_KEY);
    setSuggestions([]);
  };
  const renderSuggestion = (suggestion: any) => {
    if (suggestion.type == "clear") {
      return (
        <div className={clearSearch} onClick={handleClearSearch}>
          <hr />
          <span id={"clear-recent"}>Clear Recent</span>
        </div>
      );
    } else if (suggestion.type == "find-hotels") {
      return (
        <CurrentLocation onClick={getLocation}>
          <LocationIcon is="svg" alt="Current Location" />
          <span id="find-hotels-near-me">Use My Current Location</span>
        </CurrentLocation>
      );
    } else {
      // const formatSuggestion = formatSuggestionName(suggestion, inputValue);
      return (
        <div className={truncateString}>
          {formatSuggestionName(
            suggestion.description || suggestion.name,
            inputValue
          )}
        </div>
      );
    }
  };
  const inputComponent = (inputProps: any) => {
    return renderInputComponent(inputProps, isLoading, errors);
  };
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(getPosition, getPositionError);
    }
  };
  const getPosition = (position: any) => {
    const coords = position.coords;
    setCoordinates
      ? setCoordinates({
          name: "My Current Location",
          lat: coords.latitude,
          lon: coords.longitude,
        })
      : null;
    setIsMyLocation(true);
    setValue("My Current Location");
    setSuggestions([]);
  };
  const getPositionError = () => {
    /**
       * @todo
       * handle different errors and show message. For now just reset state.
       *
      switch(error.code) {
        case error.PERMISSION_DENIED:
          x.innerHTML = "User denied the request for Geolocation."
          break;
        case error.POSITION_UNAVAILABLE:
          x.innerHTML = "Location information is unavailable."
          break;
        case error.TIMEOUT:
          x.innerHTML = "The request to get user location timed out."
          break;
        case error.UNKNOWN_ERROR:
          x.innerHTML = "An unknown error occurred."
          break;
      }*/
    setValue("My Current Location");
    setSuggestions([]);
    props.setLocationError(true);
    setIsMyLocation(false);
  };
  const getSectionSuggestions = (section: any) => {
    if (section !== undefined) {
      return section.data;
    }
    return [];
  };
  const onAutocompleteChange = (
    _event: any,
    { newValue }: { newValue: string }
  ) => {
    if (newValue === props.searchString) {
      setIsoptionSelected("Initial");
    }
    if (props.searchString !== "" || newValue !== props.searchString) {
      setIsoptionSelected("Changed");
    }
    if (newValue === "") {
      setValue("");
    }
    setOverlayTop();
    setValue(newValue);
    errors && setErrors("");
  };
  const handleBlur = (
    _event: any,
    { highlightedSuggestion }: { highlightedSuggestion: any }
  ) => {
    props.setSearchStringStatus(isoptionSelected);
    if (
      (!highlightedSuggestion &&
        _event.currentTarget.value !== props.searchString &&
        !isMyLocation) ||
      isoptionSelected === "Changed"
    ) {
      setValue("");
      setCoordinates ? setCoordinates({ name: "", lat: "", lon: "" }) : null;
    }
    props.setIsKeyInLocation ? props.setIsKeyInLocation(false) : null;
  };
  const handleSearchFocus = (event: any) => {
    props.clearLocationRequiredError();
    if (location.pathname == "/") {
      isMobileOnly ? setValue("") : null;
    } else {
      event.target.setSelectionRange(0, event.target.value.length);
    }
    props.onSearchFocus && props.onSearchFocus();
    setErrors("");
  };
  const handleOnKeyPress = () => {
    props.setIsKeyInLocation ? props.setIsKeyInLocation(true) : null;
    setIsMyLocation(false);
  };
  const inputProps: {
    placeholder: string;
    value: any;
    onChange: any;
    onBlur: any;
    onClick: any;
    onKeyPress: any;
    className: string;
    id: any;
    ref: any;
    "aria-labelledby": string;
  } = {
    placeholder: "Find a destination",
    value,
    onChange: onAutocompleteChange,
    onBlur: handleBlur,
    onClick: handleSearchFocus,
    onKeyPress: handleOnKeyPress,
    className: `rounded ${errors && " form-control is-invalid"}`,
    id: props.id,
    ref: props.inputRef,
    "aria-labelledby": "global-search-autocomplete-label",
  };
  return (
    <Wrapper>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        renderInputComponent={inputComponent}
        renderSuggestionsContainer={renderSuggestionsContainer}
        multiSection={true}
        highlightFirstSuggestion={!isLoading}
        focusInputOnSuggestionClick={false}
        renderSectionTitle={renderSectionTitle}
        getSectionSuggestions={getSectionSuggestions}
        alwaysRenderSuggestions={false}
        shouldRenderSuggestions={shouldRenderSuggestions}
        inputProps={inputProps}
      />
    </Wrapper>
  );
};

export default SearchAutoComplete;
